import { request } from '@/shared/api/request'

export const getEmployeeRequests = ({ srcText = '', page = 0, size = 50 }) =>
    request({ url: `contract/persCard/employee/searchReq?srcText=${srcText}&page=${page}&size=${size}`, method: 'GET' })
